import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userId: "",
    redirectUrl: "",
  },
  mutations: {
    setUser(state, userId) {
      state.userId = userId
    },
    getRedirectUrl() {      
      this.state.redirectUrl = localStorage.getItem('redirectUrl')
    },
    setRedirectUrl(state, url) {
      state.redirectUrl = url
      localStorage.setItem('redirectUrl', url);
    },
  },
  actions: {
  },
  modules: {
  }
})
